$(() => {
	var url: any = $('#noticia-full-url').val();
	$('#noticia-full-url').remove();

	// $("#print_button").click(function(){
	//     $("div.PrintArea").printArea({mode: "iframe", extraCss: "/public/css/site/print.css" });
	// });

	// $('#fontA_button').click(function(){
	//     var tamanhoFonte = $('.noticia-info').css('font-size');
	//     var tf = parseFloat(tamanhoFonte);
	//     if(tf < 29){
	//         $(".noticia-info").css({'font-size' : tf + 5});
	//     }
	// });

	// $('#fontD_button').click(function(){
	//     var tamanhoFonte = $('.noticia-info').css('font-size');
	//     var tf = parseFloat(tamanhoFonte);
	//     if(tf > 14){
	//         $(".noticia-info").css({'font-size' : tf - 5});
	//     }
	// });

	// $('#textB_button').click(function(){
	//     var backG = $('.noticia-info').css('background-color');
	//     if(backG == 'rgb(0, 0, 0)'){
	//         $(".noticia-info").css({'background-color' : '#fff'});
	//         $(".noticia-info").css({'color' : '#333'});
	//     }else{
	//         $(".noticia-info").css({'color' : 'yellow'});
	//         $(".noticia-info").css({'background-color' : '#000'});
	//     }
	// });

	$('.n-c-social-btn.fb').click(() => {
		window.open(
			'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});

	$('.n-c-social-btn.tw').click(() => {
		window.open(
			'http://twitter.com/share?url=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});

	// Like

	// var id = $('#n-id').val();
	// var titulo = $('#n-titulo').val();
	// var cookie = $.cookie(`${titulo}-liked`);
	// var hasLiked = cookie;
	// var likes = parseInt($('.n-c-like-btn-likes').html());
	// $('#n-liked').val(cookie);

	// if ($('#n-liked').val() != '') {
	// 	$('.n-c-like-btn').addClass('n-c-liked');
	// }

	// $('.n-c-like-btn').off('click');
	// $('.n-c-like-btn').click(() => {
	// 	let data = {
	// 		action: 'imprensa/noticia_like',
	// 		id: id
	// 	};

	// 	if (!hasLiked) {
	// 		$.cookie(`${titulo}-liked`, true);
	// 		$('.n-c-like-btn').addClass('n-c-liked');
	// 		data['liked'] = 1;
	// 		likes = likes + 1;
	// 		$('.n-c-like-btn-likes').html(likes);
	// 		hasLiked = true;
	// 	} else {
	// 		$.removeCookie(`${titulo}-liked`);
	// 		$('.n-c-like-btn').removeClass('n-c-liked');
	// 		data['liked'] = 2;
	// 		likes = likes - 1;
	// 		$('.n-c-like-btn-likes').html(likes);
	// 		hasLiked = false;
	// 	}

	// 	$.post('/load', data, function(r) {});
	// });
});
